exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable .columnSelected[data-v-0d6c8bca] {\n  background-color: #0d2535 !important;\n  color: white;\n}\ntable tr.rowSelected > td.columnSelected[data-v-0d6c8bca] {\n  background-color: cornflowerblue;\n  font-width: bold;\n}\ntable td.rate[data-v-0d6c8bca], th.rate[data-v-0d6c8bca] {\n  text-align: center;\n}\ntable tr[data-v-0d6c8bca] {\n  cursor: pointer;\n}\ntable tr:hover td[data-v-0d6c8bca] {\n  background-color: #f2f6ff;\n}\ntable tr.rowSelected[data-v-0d6c8bca] {\n  background-color: lightyellow !important;\n}\n.ant-input[data-v-0d6c8bca] {\n  text-align: center;\n}\n", ""]);

// exports
